import { WorkoutName } from 'interfaces/workout'
import { useActiveRound, useCurrentRound, useWorkoutSession } from 'store/workout/selectors'
import useRoundComplete from 'lib/hooks/useRoundComplete'
import { roundIdToLocalStorage } from 'lib/workoutData'
import { getRoundStats, getWorkoutDuration } from 'lib/stats'
import { getRoundDisplayForceHits } from 'lib/hit-combinations'
import { checkIfRoundHasChallenges } from 'lib/challenges'
import Main from 'layout/main'
import StatsRoundComplete from 'components/stats/stats-round-complete'
import Header from 'components/header/header'
import HeaderActive from 'components/header/active'
import ForceGraphRound from 'components/graph-rounds/force-graph-round'
import ChallengeFeedback from 'components/challenge/challenge-feedback'
import { RoundCompleteFooter } from 'components/rounds-fragments/round-complete-footer'
import useCountdown from 'lib/hooks/useCountdown'
import { useNextStep } from 'lib/hooks/useNextStep'
import { useTrippleBellSound } from 'lib/hooks/useSounds'
import useStartSoundTransition from 'lib/hooks/useStartSoundTransition'

// Displaying results of the round that just finished
const RoundComplete = () => {
  const { roundId, isLoading } = useRoundComplete()
  const nextStep = useNextStep()
  const workoutSession = useWorkoutSession()
  const activeRound = useActiveRound()
  const currentRound = useCurrentRound()
  const playStartSound = useTrippleBellSound()
  const hasNextRound = activeRound + 1 < workoutSession.rounds.length
  const playNextRoundStartSound = () => {
    if (workoutSession.name === WorkoutName.FREESTYLE && hasNextRound) {
      playStartSound()
    }
  }
  const handleNextStep = useStartSoundTransition(playNextRoundStartSound, nextStep)
  const { duration } = getRoundStats(currentRound)
  const maxForce = Math.max(...getRoundDisplayForceHits(currentRound).map((hit) => hit.force), 0)

  const timeLeft = getWorkoutDuration({ ...workoutSession, rounds: workoutSession.rounds.slice(activeRound - 1) })
  const hasChallenges = checkIfRoundHasChallenges(currentRound)

  roundIdToLocalStorage(roundId)
  useCountdown({
    initCount: currentRound.breakSeconds,
    cb: handleNextStep,
    enabled: !isLoading,
  })

  const renderGraphChallenge = hasChallenges ? (
    <ChallengeFeedback />
  ) : (
    <ForceGraphRound roundData={currentRound} maxForce={maxForce} roundTime={duration} roundComplete={true} />
  )
  if (isLoading) {
    return (
      <Main className="nextround">
        <div className="component RoundComplete">
          <Header title={<h1>Saving round, please wait...</h1>} />
        </div>
      </Main>
    )
  }
  return (
    <Main className="nextround">
      <div className="component RoundComplete">
        <Header title={<h1>{`Round ${activeRound + 1} completed`}</h1>} />
        <HeaderActive value={timeLeft} text="Time left" />
        <div className="row RoundComplete__stats">
          <div className="col-3">
            <StatsRoundComplete />
          </div>
          <div className="col-9">
            <div className="RoundComplete__chart">{renderGraphChallenge}</div>
          </div>
        </div>
        <div className="row col-12">
          <RoundCompleteFooter initCount={currentRound.breakSeconds} onComplete={handleNextStep} />
        </div>
      </div>
    </Main>
  )
}

export default RoundComplete
